"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var reducer_1 = require("../restaurant/reducer");
var lodash_1 = require("lodash");
var initState = {
    items: [],
    rcm: [],
    tipPercent: 0,
    tipAmount: 0,
    taxPercent: 0,
    cutleryCount: 0,
    subtotal: 0,
    notes: '',
    pickupTime: '',
    table: '',
    type: reducer_1.RestaurantDeliveryType.Dinein,
    paymentTab: 0
};
exports.default = (function (state, action) {
    var _a;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case actions_1.ADD_ITEM:
            return __assign(__assign({}, state), { items: __spreadArray([__assign(__assign({}, (0, lodash_1.cloneDeep)(action.product)), { quantity: action.quantity })], state.items, true) });
        case actions_1.CHANGE_ITEM:
            return __assign(__assign({}, state), { items: state.items.map(function (item, index) {
                    if (index !== action.id)
                        return item;
                    return __assign(__assign({}, action.product), { quantity: action.quantity });
                }) });
        case actions_1.ADD_ITEM_QUANTITY:
            return __assign(__assign({}, state), { items: state.items.map(function (item, index) {
                    if (index !== action.itemIndex)
                        return item;
                    return __assign(__assign({}, item), { quantity: item.quantity + 1 });
                }) });
        case actions_1.REMOVE_ITEM_QUANTITY:
            return __assign(__assign({}, state), { items: state.items.map(function (item, index) {
                    if (index !== action.itemIndex)
                        return item;
                    return __assign(__assign({}, item), { quantity: item.quantity - 1 });
                }) });
        case actions_1.REMOVE_ITEM:
            return __assign(__assign({}, state), { items: state.items.filter(function (_, index) { return index !== action.itemIndex; }) });
        case actions_1.CHANGE_TIPS_PERCENT:
            return __assign(__assign({}, state), { tipPercent: action.tip.value });
        case actions_1.CHANGE_TIPS_AMOUNT:
            return __assign(__assign({}, state), { tipAmount: action.amount });
        case actions_1.CHANGE_ATTRIBUTE:
            return __assign(__assign({}, state), (_a = {}, _a[action.attribute] = action.value, _a));
        case actions_1.CHANGE_NOTE:
            return __assign(__assign({}, state), { notes: action.value });
        case actions_1.BASKET_CLEAR:
            return initState;
        default:
            return state;
    }
});
